// To control the order in which shared components are loaded
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GuestRouting } from './guest.routing';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GuestApplyComponent } from './apply/apply.component';
import { GuestRegisterComponent } from './register/register.component';
import { SpeedTestModule } from 'ng-speed-test';
import { GuestProceedComponent } from './proceeed/proceed.component';
import { CookieService } from 'ngx-cookie-service';

@NgModule({
  declarations: [GuestApplyComponent, GuestRegisterComponent, GuestProceedComponent],
  exports: [GuestApplyComponent, GuestRegisterComponent, GuestProceedComponent],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    GuestRouting,
    FormsModule,
    SpeedTestModule,
    ReactiveFormsModule,
  ],
  providers: [CookieService],
})
export class GuestModule {
  constructor() {
    console.log('>>> GuestModule loaded');
  }
}

console.log('guest.module.ts');
